import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import './Login.css';
import looogo from './images/CompanyLogo.svg';
import goo from './images/icons8-google-48.png';
import gith from './images/icons8-github-94.png';

function Login() {
    const [formData, setFormData] = useState({
        emailOrPhone: '',
        password: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };
console.log("process.env.REACT_APP_API_URL",process.env.REACT_APP_API_URL)
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, 
                {
                    emailOrPhone: formData.emailOrPhone,
                    password: formData.password
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    withCredentials: true
                }
            );

            if (response.data) {
                toast.success('Login successful!');
                navigate('/');
            }
        } catch (error) {
            console.error('Login error:', error);
            toast.error(error.response?.data?.message || 'Login failed');
        } finally {
            setIsLoading(false);
        }
    };

    const handleGoogleLogin = () => {
        window.location.href = `${process.env.REACT_APP_API_URL}/auth/google`;
    };

    const handleGithubLogin = () => {
        window.location.href = `${process.env.REACT_APP_API_URL}/auth/github`;
    };

    return (
        <div className="login-container">
            <Link to="/">
                <img src={looogo} className="looogo" alt="Logo" />
            </Link>
            <div className="left">
                <h1>Welcome Back .!</h1>
                <Link to="/" className="skip-lag">Skip the lag ?</Link>
                <div className="dotted-line"></div>
            </div>
            <div className="right">
                <div className="blur-background"></div>
                <form className="login-form" onSubmit={handleSubmit}>
                    <h2>Login</h2>
                    <p>Glad you're back.!</p>
                    <input
                        type="text"
                        name="emailOrPhone"
                        value={formData.emailOrPhone}
                        onChange={handleChange}
                        placeholder="Email or Phone"
                        required
                    />
                    <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="Password"
                        required
                    />
                    <div className="remember-me">
                        <input type="checkbox" id="remember" />
                        <label htmlFor="remember">Remember me</label>
                    </div>
                    <button 
                        type="submit" 
                        className="login-button"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Logging in...' : 'Login'}
                    </button>
                    <Link to="/pass" className="forgot-password">Forgot password ?</Link>
                    <div className="alternative-login">
                        <p>Or</p>
                        <div className="socialicons">
                            <button 
                                type="button"
                                onClick={handleGoogleLogin}
                                className="social-login-btn"
                            >
                                <img src={goo} alt="Google" />
                            </button>
                            <button 
                                type="button"
                                onClick={handleGithubLogin}
                                className="social-login-btn"
                            >
                                <img src={gith} alt="GitHub" />
                            </button>
                        </div>
                    </div>
                    <p>
                        Don't have an account ? <Link to="/signup">Signup</Link>
                    </p>
                    <div className="footer-links">
                        <Link to="/terms">Terms & Conditions</Link>
                        <Link to="/support">Support</Link>
                        <Link to="/customer-care">Customer Care</Link>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Login;